import { Component, HostListener, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateService, Translation } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { AuthService } from '@/services/auth.service';
import { PublicRoutes } from '@/models/appRoutes';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  template: ` <router-outlet></router-outlet> `,
})
export class AppComponent implements OnInit {
  primengSrv = inject(PrimeNG);
  translateSrv = inject(TranslateService);
  authSrv = inject(AuthService);
  private router = inject(Router);

  @HostListener('window:mousemove')
  @HostListener('window:keydown')
  @HostListener('window:click')
  refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  userActivity: any;
  timeoutDuration = 60000 * 60; // 1 hour in milliseconds

  setTimeout() {
    this.userActivity = setTimeout(() => {
      this.authSrv.logout().subscribe(() => {
        this.router.navigate(['/', PublicRoutes.Login]);
      });
    }, this.timeoutDuration);
  }

  ngOnInit() {
    this.translateSrv.onLangChange.subscribe((event) => {
      const { primeng } = event.translations;
      this.primengSrv.setTranslation(event.lang !== 'en' ? (primeng as Translation) : {});
    });

    if (window.location.hostname === 'app.myfreight360.com') {
      this.initAccessibility();
    }
  }

  private initAccessibility(): void {
    if (!environment.loadAccessibility) return;

    (window as any).args = {
      sitekey: '056a2bd0b5d1b06dc7c96fc35e15f7fc',
      position: 'Left',
      container: '',
      icon: '',
      access: 'https://vee-crm.com',
    };

    const script = document.createElement('script');
    script.src = (window as any).args.access + '/js/';
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.referrerPolicy = 'origin';
    script.setAttribute('data-cfasync', 'true');

    document.body.appendChild(script);
  }
}
